import { render } from "./LocationFormL1.vue?vue&type=template&id=319f33b8"
import script from "./LocationFormL1.vue?vue&type=script&lang=js"
export * from "./LocationFormL1.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__